<ion-header
  class="ion-no-border"
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'ion-header-modal-tablet'
        : 'ion-header-modal-mobile'
      : 'ion-header-modal-desktop'
  "
>
  <ion-toolbar>
    <ion-buttons
      *ngIf="(platformService?.isTouchExperience$ | async) === false"
      slot="end"
    >
      <ion-button
        id="close-modal-btn"
        data-cy="close-modal-btn"
        (click)="dismiss()"
      >
        <ion-icon
          slot="icon-only"
          name="close-outline"
          data-cy="close-modal-btn-icon"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-label data-cy="exception-popover-text">
      {{ 'i18n.search.exceptionPopover.title' | translate }}
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content
  class="product-exception-popover_content"
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'ion-content-modal-tablet'
        : 'ion-content-modal-mobile'
      : 'ion-content-modal-desktop'
  "
>
  <div class="main-container">
    <p
      *ngIf="
        product?.summary?.salesPackSize !==
        replacementProduct?.summary?.salesPackSize
      "
      data-cy="exception-popover-description-text"
    >
      {{ 'i18n.search.exceptionPopover.description' | translate }}
    </p>
    <section>
      <section>
        <h4 data-cy="exception-popover-original-product-text">
          {{ 'i18n.search.exceptionPopover.original' | translate }}
        </h4>
        <app-product-card-popover
          [product]="product"
          [quantityInputsDisabled]="true"
          [quantityUnit]="exceptionResolution?.orderItem?.unitsOrdered"
          [quantityEach]="exceptionResolution?.orderItem?.eachesOrdered"
          [platformEnum]="platformService.platformType"
          [mode]="mode"
          [navigationDisabled]="
            (orderService.restrictNavigationForCurrentOrder$ | async) || false
          "
        >
        </app-product-card-popover>
      </section>
      <section>
        <h4 data-cy="exception-popover-substitute-product-text">
          {{ 'i18n.search.exceptionPopover.substitute' | translate }}
        </h4>
        <app-product-card-popover
          *ngIf="!replacementProduct?.alternative?.product"
          [product]="replacementProduct"
          [quantityEach]="quantityEach"
          [quantityUnit]="quantityUnit"
          [quantityInputsDisabled]="
            replacementProduct?.summary?.properties.has(
              productPropertiesEnum.discontinued
            ) ||
            replacementProduct?.summary?.properties.has(
              productPropertiesEnum.outOfStock
            )
          "
          (quantityUpdateEmitter)="updateQuantity($event)"
          [platformEnum]="platformService.platformType"
          [navigationDisabled]="
            (orderService.restrictNavigationForCurrentOrder$ | async) || false
          "
          [mode]="mode"
        >
        </app-product-card-popover>
        <app-product-card-popover
          *ngIf="!!replacementProduct?.alternative?.product"
          [product]="replacementProduct?.alternative.product"
          [quantityEach]="quantityEach"
          [quantityUnit]="quantityUnit"
          [quantityInputsDisabled]="
            replacementProduct?.alternative.product?.summary?.properties.has(
              productPropertiesEnum.discontinued
            ) ||
            replacementProduct?.alternative.product?.summary?.properties.has(
              productPropertiesEnum.outOfStock
            )
          "
          (quantityUpdateEmitter)="updateQuantity($event)"
          [platformEnum]="platformService.platformType"
          [navigationDisabled]="
            (orderService.restrictNavigationForCurrentOrder$ | async) || false
          "
          [mode]="mode"
        >
        </app-product-card-popover>
      </section>
    </section>
  </div>
</ion-content>

<ion-footer
  class="ion-footer-modal"
  [class.ion-footer-modal-desktop]="
    (platformService?.isTouchExperience$ | async) === false
  "
>
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        id="cancel-modal-btn"
        data-cy="cancel-modal-btn"
        [ngClass]="
          platformService.platformType !== platformService.platformEnum.mobile
            ? 'usf-outline-green-dsktp-tblt-modal-button'
            : 'usf-outline-green-mobile-modal-button'
        "
        class="usf-outline-green-dsktp-tblt-modal-button"
        (click)="dismiss()"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>
      <ion-button
        [ngClass]="
          platformService.platformType !== platformService.platformEnum.mobile
            ? isDisabledConfirm
              ? 'usf-fill-disabled-dsktp-tblt-modal-button'
              : 'usf-fill-green-dsktp-tblt-modal-button'
            : isDisabledConfirm
              ? 'usf-fill-disabled-mobile-modal-button'
              : 'usf-fill-green-mobile-modal-button'
        "
        class="usf-fill-green-dsktp-tblt-modal-button"
        data-cy="resolve-exception-button"
        (click)="confirmResolveException()"
      >
        {{ 'i18n.search.exceptionPopover.confirmQuantity' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
